export default class UrlService {
  // Ensures root window in case of iframe use
  // (e.g. Storybook preview)
  static rootWindow = window.parent || window;

  static getSearchParams() {
    const { search } = this.rootWindow.location;

    if (search) {
      return search
        .slice(1)
        .split("&")
        .reduce((all, current) => {
          const [key, value] = current.split("=");

          // Check if array
          if (/\[\d+\]$/.test(key)) {
            const [, keyString, index] = key.match(/(.+)\[(\d+)\]/);
            if (!(keyString in all)) {
              all[keyString] = [];
            }
            all[keyString][index] = value;
          } else {
            all[key] = value;
          }
          return all;
        }, {});
    }

    return {};
  }

  static toSearchParamsString(paramsObject) {
    const params = Object.entries(paramsObject)
      .map(([key, values]) => {
        if (Array.isArray(values)) {
          if (values.length > 1) {
            return values
              .map((value, index) => `${key}[${index}]=${value}`)
              .join("&");
          }

          return `${key}=${values[0]}`;
        }

        return `${key}=${values}`;
      })
      .join("&");

    return `?${params}`;
  }

  static get pathName() {
    return this.rootWindow.location.pathname;
  }
}
